import React from 'react';
import { PlaceholderUFOMigration as Placeholder } from '@atlassian/jira-placeholder/src/index.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
import type { KnowledgeBaseNav, KnowledgeBaseNavWithUseResource } from './ui/index.tsx';

const LazyKbNav = lazyForPaint<typeof KnowledgeBaseNav>(
	() =>
		import(/* webpackChunkName: "async-kb-nav" */ './ui').then(
			({ KnowledgeBaseNav }) => KnowledgeBaseNav,
		),
	{
		includeInShellOnlySsrBundle: true,
	},
);

const LazyKbNavWithUseResource = lazyForPaint<typeof KnowledgeBaseNavWithUseResource>(
	() =>
		import(/* webpackChunkName: "async-kb-nav-with-use-resource" */ './ui').then(
			({ KnowledgeBaseNavWithUseResource }) => KnowledgeBaseNavWithUseResource,
		),
	{
		includeInShellOnlySsrBundle: true,
	},
);

export const AsyncKbNav = () => {
	return (
		<ErrorBoundary id="horizontal-jsm-kb-nav" packageName="jira-horizontal-nav-jsm-knowledge-base">
			<Placeholder name="horizontal-jsm-kb-nav">
				{fg('jsm-kb-articles-functional') ? <LazyKbNavWithUseResource /> : <LazyKbNav />}
			</Placeholder>
		</ErrorBoundary>
	);
};
